import {FormControl} from 'platform/components';

import {UseFormReturn, useController} from 'react-hook-form';

import {TestIdProps} from 'shared/web';

import {FilterFormData} from '../../../../types/FilterFormData';
import {FeaturesFilterFieldBody} from './FeaturesFilterFieldBody';
import {useFeaturesFilterFieldState} from './hooks/useFeaturesFilterFieldState';

interface FeaturesFilterFieldProps extends TestIdProps {
  formControl: FormControl<FilterFormData>;
  formApi: UseFormReturn<FilterFormData>;
}

const EMPTY_FEATURES: string[] = [];

export function FeaturesFilterField(props: FeaturesFilterFieldProps) {
  const {field} = useController({
    name: 'features',
    control: props.formApi.control,
  });
  const features = field.value ?? EMPTY_FEATURES;

  const fieldState = useFeaturesFilterFieldState({
    features,
    onFeaturesChange: (value) => {
      field.onChange(value);
      props.formControl.onChange?.();
    },
  });

  return (
    <FeaturesFilterFieldBody variant="stacked" {...fieldState} data-testid={props['data-testid']} />
  );
}
